module.exports = __webpack_public_path__ + "static/media/imagem41.1396937f.jpeg";